import { forwardRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

// Password input with a built-in eye toggle. Drop-in replacement for
// <Input type="password" … />. Forwards all other props to <Input>.
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testid, ...rest },
  ref,
) {
  const [visible, setVisible] = useState(false);
  const toggleId = testid ? `${testid}-toggle` : "password-toggle";

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testid}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-slate-700"
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={toggleId}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
